import { doc, getDoc, setDoc } from 'firebase/firestore';
import { db, PROFILES_PATH } from 'src/firebase';
import { defaultDisclaimer } from 'src/workbench/helpers/constants';
import { ProfileDoc } from 'src/workspace/workspace.interfaces';

class ProfileService {
  getProfile = async (id: string): Promise<ProfileDoc | null> => {
    const profileRef = doc(db, PROFILES_PATH, id);
    const profileDoc = await getDoc(profileRef);
    return profileDoc.exists() ? (profileDoc.data() as ProfileDoc) : null;
  };
  createProfile = async (id: string, data: Partial<ProfileDoc>) => {
    const profileRef = doc(db, PROFILES_PATH, id);
    await setDoc(profileRef, {
      ...defaultProfile,
      ...data,
    });
  };
  updateProfile = async (
    id: string,
    data: Partial<ProfileDoc>,
  ): Promise<void> => {
    const profileRef = doc(db, PROFILES_PATH, id);
    await setDoc(profileRef, data, { merge: true });
  };
}
export const profileService = new ProfileService();

const defaultProfile: ProfileDoc = {
  contractorName: '',
  contractorAddress: '',
  contractorLogo: '',
  disclaimer: defaultDisclaimer,
};
